import { ArticlePresentationFormat, HemingwayLinkType, } from '../../../types.js';
export function getLinkFollowType(link) {
    if (!link) {
        return undefined;
    }
    const isExternalLink = link.__typename === HemingwayLinkType.External;
    const isInternalLink = link.__typename === HemingwayLinkType.Internal;
    const isNoFollowNode = link.__typename === HemingwayLinkType.Sitemap && shouldNodeGetNoFollow(link);
    if (isExternalLink || isInternalLink || isNoFollowNode) {
        return 'nofollow';
    }
    return undefined;
}
// isFilterPage is only true when /filter is part of the url, this is set in the backend.
// Filter pages without /filter (and thus no storefronts) should NOT get a nofollow.
function shouldNodeGetNoFollow(link) {
    return (link.isFilterPage ||
        link.sitemapNode.urlIndexable === false ||
        link.sitemapNode.presentationFormat === ArticlePresentationFormat.BrandedPage);
}
//# sourceMappingURL=getLinkFollowType.js.map